import { render, staticRenderFns } from "./floorDetails.vue?vue&type=template&id=95f4c478&scoped=true&"
import script from "./floorDetails.vue?vue&type=script&lang=js&"
export * from "./floorDetails.vue?vue&type=script&lang=js&"
import style0 from "./floorDetails.vue?vue&type=style&index=0&id=95f4c478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f4c478",
  null
  
)

component.options.__file = "floorDetails.vue"
export default component.exports